import { Alert, AlertTitle, SxProps, Theme } from '@mui/material'
import React from 'react'

interface AlertBannerProps {
  variant?: 'filled' | 'outlined' | 'standard'
  severity?: 'error' | 'warning' | 'info' | 'success'
  sx?: SxProps<Theme>
  titleSx?: SxProps<Theme>
  title?: string | JSX.Element
  description?: string | JSX.Element
}

export const AlertBanner: React.FC<AlertBannerProps> = ({
  variant,
  severity,
  sx,
  titleSx,
  title,
  description
}) => {
  return (
    <Alert
      variant={variant ?? 'filled'}
      severity={severity ?? 'info'}
      sx={sx}
    >
      <AlertTitle sx={titleSx}>
        {title}
      </AlertTitle>
      {description}
    </Alert>
  )
}
